import { useEffect } from 'react';
import { assignAndTagCohort } from '../utils/cohort';

/**
 * Run cohort assignment once a session sub is available. Keyed on `sub` so it
 * runs once per signed-in user and is a no-op while unauthenticated.
 */
export function useCohortAssignment(sub: string | undefined): void {
  useEffect(() => {
    if (!sub) return;
    assignAndTagCohort(sub);
  }, [sub]);
}
